import { Component, OnInit } from '@angular/core';
import { QuotationTemplate } from '../quotation-template';
import { HttpService } from '../service/http.service';
import { SchoolService } from '../service/school.service';

@Component({
  selector: 'app-school-quotation-templates',
  templateUrl: './school-quotation-templates.component.html',
  styleUrls: ['./school-quotation-templates.component.css']
})
export class SchoolQuotationTemplatesComponent implements OnInit {

  templates: QuotationTemplate[] = [];

  constructor(
    private httpService: HttpService,
    private schoolService: SchoolService
  ) { }

  ngOnInit(): void {
    this.httpService.getTemplatesBySchool(this.schoolService.selectedSchoolId).subscribe(res => {
      this.templates = res;
    });
  }

}
